import { Integration, IntegrationCreate, IntegrationUpdate } from '@kibsi/ks-tenant-types'

export interface CloudIntegrationService {
    list(): Promise<Integration[]>
    read(entityId: string): Promise<Integration>
    create(entity: IntegrationCreate): Promise<Integration>
    update(entity: IntegrationUpdate): Promise<void>
    delete(entity: Integration, cascade?: boolean): Promise<void>
}
